import { Component, Input } from '@angular/core';
import { WarningTransformationLogItem } from '../../model/warning-transformation-log-item';
import { LogItemHelper } from '../log-item-helper';

@Component({
    selector: 'tnb-warning-transformationlogitem',
    templateUrl: './warning-transformation-log-item.component.html',
    styleUrls: [
        './warning-transformation-log-item.component.scss',
    ],
    standalone: false,
})
export class WarningTransformationLogItemComponent {

    public formatArray = LogItemHelper.formatArray;

    @Input() public warningTransformationLogItem: WarningTransformationLogItem;

    constructor() {
    }

}
